import { createEntityCollectionStore } from '@core/ngrx-legacy';

import type { FormConfig } from '../../../types';

const { actions, namespace, selectors, reducer } =
  createEntityCollectionStore<FormConfig>()('FormConfig');

export {
  actions as FormConfigActions,
  namespace as FormConfigNamespace,
  reducer as FormConfigReducer,
  selectors as FormConfigSelectors,
};
